import { gql } from '@apollo/client';
import { ReviewedCountFragment } from '@/shared/api';

const HOLTER_BEAT_EVENTS_COUNT_QUERY = gql`
  query holterBeatEventsCount($filter: HolterEventsFilter!) {
    holterBeatEventsCount(filter: $filter) {
      isSuccess
      message
      veCouplet ${ReviewedCountFragment}
      veBigeminy ${ReviewedCountFragment}
      veTrigeminal ${ReviewedCountFragment}
      veRun ${ReviewedCountFragment}
      veQuadrigeminy ${ReviewedCountFragment}
      sveCouplet ${ReviewedCountFragment}
      sveBigeminy ${ReviewedCountFragment}
      sveTrigeminal ${ReviewedCountFragment}
      sveRun ${ReviewedCountFragment}
      sveQuadrigeminy ${ReviewedCountFragment}
    }
  }
`;

export default HOLTER_BEAT_EVENTS_COUNT_QUERY;
